// extracted by mini-css-extract-plugin
export default {"title":"myAchieve_title__8AMt0","achievementsGrid":"myAchieve_achievementsGrid__CmDtm","emptyText":"myAchieve_emptyText__o-Ms4","errorText":"myAchieve_errorText__Dts0O"};